import React from 'react';
import {Form} from "../lib/Form";
import {useBizTypes} from "../lib/bridgeHooks";
import {find} from 'lodash';

//TODO Validation & error handling
//TODO set keyboard

export default function CompanyForm({company={}, ...props}){

    const {pickerDataTree} = useBizTypes();

    const getTypes = category => {
        const cat = find(pickerDataTree, {category});
        return cat ? cat.types : [];
    };

    const fields = [
        {
            id: 'name',
            decorator: {
                rules: [{
                    required: true,
                    whitespace: true,
                    message: 'name in ad required'
                }],
                initialValue: company.name,
            },
            label: 'Name'
        },
        {
            id: 'category',
            decorator: {
                initialValue: company.category,
            },
            label: 'Category',
            type: 'Picker',
            data: pickerDataTree,
            valueDisplay: value => <span style={{fontSize:'14px'}}>
                {value}
            </span>
        },
        {
            id: 'type',
            decorator: {
                initialValue: company.type,
            },
            label: 'Type',
            type: 'Picker',
            data: getTypes(company.category),  // not sure if we need this
            dataDep: 'category',  // watch this field id and pass value to dataFn
            dataFn: getTypes,
            valueDisplay: value => <span style={{fontSize:'14px'}}>
                {value}
            </span>
        },
        {
            id: 'address',
            decorator: {
                rules: [{
                    max: 100,
                    message: 'text too long'
                }],
                initialValue: company.address,
            },
            label: 'Address'
        },
        {
            id: 'city',
            decorator: {
                rules: [{
                    max: 100,
                    message: 'text too long'
                }],
                initialValue: company.city,
            },
            label: 'City'
        },
        {
            id: 'state',
            decorator: {
                rules: [{
                    max: 100,
                    message: 'text too long'
                }],
                initialValue: company.state,
            },
            label: 'State'
        },
        {
            id: 'zip',
            decorator: {
                validateTrigger: 'onBlur',
                rules: [{
                    max: 5,
                    message: 'text too long'
                }],
                initialValue: company.zip,
            },
            label: 'Zip'
        },
        {
            id: 'web',
            decorator: {
                rules: [{
                    max: 100,
                    message: 'text too long'
                }],
                initialValue: company.web,
            },
            label: 'Web'
        },
        {
            id: 'phone',
            decorator: {
                rules: [{
                    max: 100,
                    message: 'text too long'
                }],
                initialValue: company.phone,
            },
            label: 'Phone',
            //type: 'number',  //type: 'phone'  // antd mobile has wrong pattern defined 3-4-3
            //pattern: "[0-9]{3} [0-9]{3} [0-9]{4}"  // no way to pass thru..
        }
    ];

    return (
        <Form
            fields={fields}
            headerText={'Enter advertiser details'}
            resetText={'Undo'}
            showClear={true}
            labelNumber={4}
            {...props}
        />
    );
}